module.exports = __webpack_public_path__ + "static/img/product-15.7684e5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-15.png
// module id = sJhu
// module chunks = 0